import { Button } from "@/components/ui/button";
import { MoonIcon, SunIcon } from "lucide-react";

export function toggleTheme(theme?: "light" | "dark" | "system") {
  if (theme) {
    document.documentElement.classList.toggle(
      "dark",
      theme === "dark" ||
        (theme === "system" &&
          window.matchMedia("(prefers-color-scheme: dark)").matches),
    );
    localStorage.theme = theme;
    return;
  }

  if (
    document.documentElement.classList.contains("dark") ||
    (!("theme" in localStorage) &&
      window.matchMedia("(prefers-color-scheme: dark)").matches)
  ) {
    document.documentElement.classList.remove("dark");
    localStorage.theme = "light";
  } else {
    document.documentElement.classList.add("dark");
    localStorage.theme = "dark";
  }
}
export function ThemeToggle() {
  return (
    <Button
      variant="outline"
      size="icon"
      type="button"
      onClick={() => toggleTheme()}
    >
      <SunIcon className="dark:-rotate-90 size-4 rotate-0 scale-100 transition-all dark:scale-0" />
      <MoonIcon className="absolute size-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
